import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-other-data-material',
  templateUrl: './new-other-data-material.component.html',
  styleUrls: ['./new-other-data-material.component.scss'],
})
export class NewOtherDataMaterialComponent {
  @Output() savOtherDataMaterialEvent = new EventEmitter<{ payload: any; pathName: any }>();
  modalLabel: any;

  otherMaterialData: any;
  otherMaterialAddEditForm!: FormGroup;
  submitted = false;
  finalSubmitted = false;
  organizationlist: any;
  activatedRoute: any;
  selectOrganization: any;
  materialList: any;
  isMaterialTypeForm = false;
  isRecyclabilityForm = false;
  isCombustibilityForm = false;
  isCompostabilityForm = false;
  materialTypeForm!: FormGroup;
  recyclabilityForm!: FormGroup;
  combustibilityForm!: FormGroup;
  compostabilityForm!: FormGroup;

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    switch (this.activatedRoute) {
      case 'material-types':
        this.isMaterialTypeForm = true;
        break;
      case 'Recyclability':
        this.isRecyclabilityForm = true;
        break;
      case 'Combustibility':
        this.isCombustibilityForm = true;
        break;
      case 'Compostability':
        this.isCompostabilityForm = true;
        break;
      default:
        break;
    }
    this.otherMaterialData =
      this.modal?.modalService?.config?.initialState?.['newOtherMaterialData'];
    const placeHolderOrganization = {
      name: 'All organization',
      id: 0,
    };
    const newOrganizationlist = [placeHolderOrganization].concat(
      this.otherMaterialData.organizationList
    );
    this.materialList = this.otherMaterialData.materialItems;
    this.organizationlist = newOrganizationlist;
    this.organizatioListFunction();
  }

  ngOnInit(): void {
    this.otherMaterialAddEditForm = this.formBuilder.group({
      material: [this.otherMaterialData.materialId || null, Validators.required],
      organizationName: [this.otherMaterialData.organizationId || this.organizationlist[0] || null],
      materialTypeForm: this.formBuilder.group({
        plasticResin: [this.otherMaterialData.plasticResin || 0, Validators.required],
        paperBoard: [this.otherMaterialData.paperBoard || 0, Validators.required],
        metals: [this.otherMaterialData.metals || 0, Validators.required],
        glass: [this.otherMaterialData.glass || 0, Validators.required],
        otherMaterials: [this.otherMaterialData.otherMaterials || 0, Validators.required],
      }),
      recyclabilityForm: this.formBuilder.group({
        recyclabilityHigh: [this.otherMaterialData.recyclabilityHigh || 0, Validators.required],
        recyclabilityLow: [this.otherMaterialData.recyclabilityLow || 0, Validators.required],
        recyclabilityMedium: [this.otherMaterialData.recyclabilityMedium || 0, Validators.required],
        recyclabilityNone: [this.otherMaterialData.recyclabilityNone || 0, Validators.required],
      }),
      combustibilityForm: this.formBuilder.group({
        combustibilityHigh: [this.otherMaterialData.combustabilityHigh || 0, Validators.required],
        combustibilityLow: [this.otherMaterialData.combustabilityLow || 0, Validators.required],
        combustibilityNone: [this.otherMaterialData.combustabilityNone || 0, Validators.required],
      }),
      compostabilityForm: this.formBuilder.group({
        compostabilityHigh: [this.otherMaterialData.compostabilityHigh || 0, Validators.required],
        compostabilityLow: [this.otherMaterialData.compostabilityLow || 0, Validators.required],
        compostabilityNone: [this.otherMaterialData.compostabilityNone || 0, Validators.required],
      }),
    });
    this.setFormData();
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.otherMaterialData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.otherMaterialAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    this.finalSubmitted = true;
    switch (this.activatedRoute) {
      case 'material-types':
        if (
          this.otherMaterialAddEditForm.status == 'VALID' &&
          this.otherMaterialAddEditForm.controls['materialTypeForm'].status == 'VALID'
        ) {
          const myOtherDataAddEditPayload = {
            materialId: this.otherMaterialData.materialId || 0,
            organizationId:
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name ==
                'All organization' ||
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name == undefined
                ? null
                : this.otherMaterialAddEditForm.controls['organizationName'].value?.id,
            plasticResin:
              this.otherMaterialAddEditForm.controls['materialTypeForm'].value.plasticResin,
            paperBoard: this.otherMaterialAddEditForm.controls['materialTypeForm'].value.paperBoard,
            metals: this.otherMaterialAddEditForm.controls['materialTypeForm'].value.metals,
            glass: this.otherMaterialAddEditForm.controls['materialTypeForm'].value.glass,
            otherMaterials:
              this.otherMaterialAddEditForm.controls['materialTypeForm'].value.otherMaterials,
          };
          this.savOtherDataMaterialEvent.emit({
            payload: myOtherDataAddEditPayload,
            pathName: this.activatedRoute,
          });
        }
        break;
      case 'Recyclability':
        if (
          this.otherMaterialAddEditForm.status == 'VALID' &&
          this.otherMaterialAddEditForm.controls['recyclabilityForm'].status == 'VALID'
        ) {
          const myOtherDataAddEditPayload = {
            materialId: this.otherMaterialData.materialId || 0,
            organizationId:
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name ==
                'All organization' ||
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name == undefined
                ? null
                : this.otherMaterialAddEditForm.controls['organizationName'].value?.id,
            recyclabilityHigh:
              this.otherMaterialAddEditForm.controls['recyclabilityForm'].value.recyclabilityHigh,
            recyclabilityMedium:
              this.otherMaterialAddEditForm.controls['recyclabilityForm'].value.recyclabilityMedium,
            recyclabilityLow:
              this.otherMaterialAddEditForm.controls['recyclabilityForm'].value.recyclabilityLow,
            recyclabilityNone:
              this.otherMaterialAddEditForm.controls['recyclabilityForm'].value.recyclabilityNone,
          };
          this.savOtherDataMaterialEvent.emit({
            payload: myOtherDataAddEditPayload,
            pathName: this.activatedRoute,
          });
        }
        break;
      case 'Combustibility':
        if (
          this.otherMaterialAddEditForm.status == 'VALID' &&
          this.otherMaterialAddEditForm.controls['combustibilityForm'].status == 'VALID'
        ) {
          const myOtherDataAddEditPayload = {
            materialId: this.otherMaterialData.materialId || 0,
            organizationId:
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name ==
                'All organization' ||
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name == undefined
                ? null
                : this.otherMaterialAddEditForm.controls['organizationName'].value?.id,
            combustabilityHigh:
              this.otherMaterialAddEditForm.controls['combustibilityForm'].value.combustibilityHigh,
            combustabilityLow:
              this.otherMaterialAddEditForm.controls['combustibilityForm'].value.combustibilityLow,
            combustabilityNone:
              this.otherMaterialAddEditForm.controls['combustibilityForm'].value.combustibilityNone,
          };
          this.savOtherDataMaterialEvent.emit({
            payload: myOtherDataAddEditPayload,
            pathName: this.activatedRoute,
          });
        }
        break;
      case 'Compostability':
        if (
          this.otherMaterialAddEditForm.status == 'VALID' &&
          this.otherMaterialAddEditForm.controls['compostabilityForm'].status == 'VALID'
        ) {
          const myOtherDataAddEditPayload = {
            materialId: this.otherMaterialData.materialId || 0,
            organizationId:
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name ==
                'All organization' ||
              this.otherMaterialAddEditForm.controls['organizationName'].value?.name == undefined
                ? null
                : this.otherMaterialAddEditForm.controls['organizationName'].value?.id,
            compostabilityHigh:
              this.otherMaterialAddEditForm.controls['compostabilityForm'].value.compostabilityHigh,
            compostabilityLow:
              this.otherMaterialAddEditForm.controls['compostabilityForm'].value.compostabilityLow,
            compostabilityNone:
              this.otherMaterialAddEditForm.controls['compostabilityForm'].value.compostabilityNone,
          };
          this.savOtherDataMaterialEvent.emit({
            payload: myOtherDataAddEditPayload,
            pathName: this.activatedRoute,
          });
        }
        break;
      default:
        break;
    }
  }
}
